import React, {Component} from 'react'
import {connect} from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import {Snackbar, SnackbarContent, Icon} from '@material-ui/core'

const styles = theme => ({
    error: {
        backgroundColor: theme.palette.error.dark
    },
    errorText: {
        color: 'white'
    },
    container: {
        display: 'flex',
        alignItems: 'center'
    }
})

class Error extends Component {

    render() {
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={this.props.open}

            >
                <SnackbarContent
                    className={this.props.classes.error}
                    message={(
                        <div className={this.props.classes.container} >
                            <Icon fontSize={'medium'}>error</Icon>
                            <span className={this.props.classes.errorText}>
                                {this.props.error}
                            </span>
                        </div>
                    )}
                />
            </Snackbar>
        )
    }
}

Error.propTypes = {
}

const mapStateToProps = (state) => {
    return {
        error: state.error.text,
        open: state.error.open
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Error))